export default "__VITE_ASSET__qfBrFb2d__"